/**
@format
@flow
*/
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import Icon from '@ziynx/components/icons';
import Colors from '@ziynx/theme/colors';
import type { IconSize } from '@ziynx/flow-types/globals';

type Props = $ReadOnly<{|
  size: string,
  color?: string,
|}>;

const buildAnimation = (): string => {
  const animationKeyframe = keyframes`
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
  return css`
    -webkit-animation: ${animationKeyframe} 2s linear infinite;
    -moz-animation: ${animationKeyframe} 2s linear infinite;
    -ms-animation: ${animationKeyframe} 2s linear infinite;
    -o-animation: ${animationKeyframe} 2s linear infinite;
    animation: ${animationKeyframe} 2s linear infinite;
  `;
};

const getSize = (size: IconSize): string => {
  switch (size) {
  case 'large':
    return '68px';
  case 'medium':
    return '44px';
  case 'small':
    return '36px';
  case 'extraSmall':
    return '24px';
  case 'veryTiny':
    return '16px';
  case 'mini':
    return '12px';
  case 'veryMini':
    return '6px';
  case 'tiny':
  default:
    return '20px';
  }
};

const Wrapper = styled.div`
  width: ${({ size }) => getSize(size)};
  height: ${({ size }) => getSize(size)};
  position: relative;
  display: flex;
  ${buildAnimation()};
`;

const LoadingSpinner = (props: Props): React$Node => {
  const { size, color, ...rest } = props;

  return (
    <Wrapper size={size} {...rest}>
      <Icon {...{ [size]: true }} name="loading" color={color} />
    </Wrapper>
  );
};

LoadingSpinner.defaultProps = {
  color: Colors.Gray,
};

export default LoadingSpinner;
